import { http, type HttpOptions } from './httpClient'
import type { Draft, DraftChangesResponse, DraftOpsRequest, DraftOpsResponse } from './types'

export const draftApi = {
  get: async (projectId: number): Promise<Draft> =>
    http.get<Draft>(`/api/projects/${projectId}/draft/`, { silent: true }),

  applyOps: (projectId: number, body: DraftOpsRequest, opts?: HttpOptions) =>
    http.post<DraftOpsResponse, DraftOpsRequest>(`/api/projects/${projectId}/draft/ops/`, body, opts),

  /** Ops aplicadas depois de `since`, para fechar um buraco de `rev`. */
  changes: (projectId: number, since: number): Promise<DraftChangesResponse> =>
    http.get<DraftChangesResponse>(
      `/api/projects/${projectId}/draft/changes/?since=${since}`,
      { silent: true },
    ),
}
